
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { measureAsyncOperation, LoadingPhase } from '../hooks/useLoadingMetrics';

// Initialize i18n asynchronously to prevent blocking
const initI18n = async () => {
  try {
    await measureAsyncOperation(
      LoadingPhase.I18N_LOADING,
      async () => {
        await i18n
          .use(Backend)
          .use(LanguageDetector)
          .use(initReactI18next)
          .init({
            fallbackLng: 'en',
            supportedLngs: ['en', 'he', 'es', 'pt'],
            interpolation: {
              escapeValue: false,
            },
            detection: {
              order: ['localStorage', 'navigator'],
              caches: ['localStorage'],
            },
            backend: {
              loadPath: '/locales/{{lng}}/{{ns}}.json',
              // Add timeout and retry configuration
              requestOptions: {
                cache: 'default',
              },
            },
            // Prevent blocking by using partialBundledLanguages
            partialBundledLanguages: true,
            // Load resources asynchronously
            initImmediate: false,
          });
        
        return {
          language: i18n.language,
          supportedLanguages: ['en', 'he', 'es', 'pt'],
          backendEnabled: true
        };
      },
      {
        detectedLanguage: navigator.language,
        supportedLanguages: 4,
        backendEnabled: true
      }
    );
  } catch (error) {
    console.warn('Failed to initialize i18n:', error);
    // Fallback to basic configuration without backend
    await measureAsyncOperation(
      LoadingPhase.I18N_LOADING,
      async () => {
        await i18n
          .use(initReactI18next)
          .init({
            fallbackLng: 'en',
            resources: {
              en: { translation: {} },
              he: { translation: {} },
              es: { translation: {} },
              pt: { translation: {} },
            },
            interpolation: {
              escapeValue: false,
            },
          });
        
        return {
          language: i18n.language,
          supportedLanguages: ['en', 'he', 'es', 'pt'],
          backendEnabled: false,
          fallbackUsed: true
        };
      },
      {
        detectedLanguage: navigator.language,
        supportedLanguages: 4,
        backendEnabled: false,
        fallbackUsed: true,
        error: error instanceof Error ? error.message : String(error)
      }
    );
  }
};

// Initialize i18n asynchronously without blocking module load
initI18n();

export default i18n;
export { initI18n };
